import Grid from '@components/core/layout/Grid';
import RichText from '@components/core/RichText';
import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import Filters from '@components/Filters';
import { Image } from '@components/core/Image';

export default function HeaderKOVFilter(props: any) {
  const {
    heading,
    intro,
    image,
    showArc,
    showFilterSearch = true,
  } = props;

  const lookUps = {
    kinderopvang: {
      BSO: 'Buitenschoolse opvang',
      POV: 'Peuteropvang',
      KDV: 'Kinderdagverblijf',
    },
  };

  type ProductType = { value: string; label: string };
  const [ selectedProductType, setProductType ] = useState<ProductType[] | null>(null);
  const [ selectedLocation, setLocation ] = useState({
    value: '',
    isValid: true,
    validState: { }, // key: type of validation, value: boolean
    showErrorMessage: false,
  });

  const [ buttonIsDisabled, setButtonIsDisabled ] = useState(true);
  const router = useRouter();

  const handleEmitLocation = (e) => {
    setLocation({
      value: e.target.value ,
      isValid: true,
      validState: { }, // key: type of validation, value: boolean
      showErrorMessage: false,
    });
    setButtonIsDisabled(false);
  };

  const applyFilter = useCallback(() => {
    // Convert to url friendly instead of options friendly
    const selectedProductValues = selectedProductType?.map( productType => productType.value).join();
    router.push({
      pathname: 'kinderopvang-locaties',
      query: {
        ...(selectedProductValues ? { productType: selectedProductValues } : {}),
        ...(selectedLocation?.value ? { location: selectedLocation.value } : {}),
      },
    }, undefined, { scroll: false });
  }, [ router, selectedProductType, selectedLocation ]);

  return (
    <div className='relative'>
      {image && (
        <div className={ `absolute inset-0 w-full overflow-hidden ${ showArc ? 'h-[calc(100%+1.5rem)] md:h-[calc(100%+2.5rem)]' : 'h-full' }` }>
          <div className='relative w-full h-full max-w-[2000px] mx-auto mt-8 rounded-[48px] overflow-hidden'>
            <Image
              sanityImage={ image.image }
              layout='fill'
              objectFit='cover'
              priority={ true }
              sizes='(min-width: 1280px) 2000px, 100vw'
            />
            <div className='absolute inset-0 bg-black/40' />
          </div>
        </div>
      )}
      <div className='relative'>
        <Grid className='pt-8 md:pt-12 xl:pt-16 pb-8 md:pb-12 xl:pb-24'>
          <div className='col-span-12 md:text-center'>
            <h1 className={ `text-heading-lg mb-2 xl:text-heading-xl xl:mb-4 2xl:text-heading-3xl ${ image ? 'text-white drop-shadow-lg' : '' }` }>
              {heading}
            </h1>
          </div>
          <div className={ `col-span-12 mb-4 md:mb-8 md:text-center xl:col-start-2 xl:col-span-10 2xl:col-start-3 2xl:col-span-8 ${ image ? 'text-white drop-shadow' : '' }` }>
            <RichText text={ intro?.text } />
          </div>
          {showFilterSearch && (
            <div className='col-span-12 md:col-span-10 md:col-start-2 p-4 bg-primary-100 rounded-[30px] xl:rounded-[60px]'>
              <div className='flex flex-col xl:flex-row'>
                <Filters
                  position='header'
                  options={ {
                    productTypes: lookUps.kinderopvang,
                  } }
                  selectedProductType={ selectedProductType }
                  selectedLocation={ selectedLocation }
                  buttonIsDisabled={ buttonIsDisabled }
                  emit={ {
                    productType: setProductType,
                    location: handleEmitLocation,
                    applyFilter,
                    disableApplyButton: setButtonIsDisabled,
                  } }
                  buttonLabel='Bekijk locaties'
                  disableLocation={ false }
                />
              </div>
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
}
